<div style="display: flex; flex-direction: column; padding: 10px">
  <h3>Please choose the right scope this budget belongs to</h3>

  <mat-form-field>
    <mat-label i18n>Scope</mat-label>
    <mat-select [(ngModel)]="budgetScope" multiple placeholder="Scope">
      @for (scope of BUDGET_SCOPES; track scope) {
        <mat-option
          [value]="scope"
          [disabled]="budgetScope.length === 3 && !budgetScope.includes(scope)"
        >{{ scope }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div mat-dialog-actions style="display: flex; justify-content: space-between">
    <button mat-raised-button mat-dialog-close [routerLink]="['budget']">Back</button>

    <button mat-raised-button (click)="save()" color="primary" [disabled]="!budgetScope.length">Save</button>
  </div>
</div>
